import { Field } from "formik";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
} from "../../components/action-buttons/ActionButtonGenerator";
import FormikForm from "../../components/crud/FormikForm";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Select from "../../components/form-fields/Select";
import Main from "../../components/main/Main";
import { useTranslation } from 'react-i18next';                   /* Added Line */

export default function AboutGhib() {
  const [authorizedModal, setAuthorizedModal] = useState(false);
  const [t, i18n] = useTranslation();         /* Added Line */

  const validationSchema = yup.object({
    departmanAdi: yup.string(),
    yetkiliKisi: yup.string().required("Gerekli alan."),
  });
  return (
    <Main>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <Modal className="modal fade" show={authorizedModal}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Grup Şirketi</h5>
                <Button
                  variant=""
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={() => setAuthorizedModal(false)}
                >
                  <span>×</span>
                </Button>
              </div>
              <div className="modal-body">
                <FormikForm
                  initialValues={{}}
                  validationSchema={validationSchema}
                  endPointUrl="https://jsonplaceholder.typicode.com/todos/1"
                >
                  <Field
                    name="grup"
                    label="Grup"
                    colNumber="12"
                    component={Select}
                    data={[{ id: 1, label: "grup 1 test" }]}
                    valueFieldName="id"
                    required
                  />
                  <Field
                    name="kurumTipi"
                    label="Kurum Tipi"
                    colNumber="12"
                    component={Select}
                    data={[{ id: 1, label: "kurum tipi 1 test" }]}
                    valueFieldName="id"
                    required
                  />
                  <Field
                    name="sirket"
                    label="Şirket"
                    colNumber="12"
                    component={TextInput}
                  />
                  <Field
                    name="ghibsorumlusu"
                    label="GHİB Sorumlusu"
                    colNumber="12"
                    component={Select}
                    data={[{ id: 1, label: "ghib sorumlusu 1 test" }]}
                    valueFieldName="id"
                    required
                  />
                  <Field
                    name="notlar"
                    label="Notlar"
                    colNumber="12"
                    component={TextInput}
                  />
                </FormikForm>
              </div>
            </div>
          </Modal>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName=""
            endpoint=""
            keyField="id"
            columns={[
              {
                dataField: "id",
                text: "ID",
                sort: true,
                headerClasses: "id-header"
              },
              {
                dataField: "ghibcc",
                text: "GHİB CC",
                sort: true,
              },
              {
                dataField: "kurumTipi",
                text: `${t("demandList.kurumTip")}`,
                sort: true,
              },
              {
                dataField: "grup",
                text: `${t("demandList.grup")}`,
                sort: true,
              },
              {
                dataField: "kurumAdi",
                text: `${t("demandList.kurumAdi")}`,
                sort: true,
              },
              {
                dataField: "durum",
                text: `${t("demandList.durum")}`,
                sort: true,
              },
            ]}
            actionButtonsObject={{
              actions: [pushToParams(ABT.EDIT, setAuthorizedModal)],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
